import React from 'react'
import { callApi } from '../utils/callApi'
import { API_ROUTES } from '../utils/apiRoutes'

export const useNsRequests = () => {
  const [requestNSPushLoading, setRequestNSPushLoading] = React.useState(false)
  const [requestNSMediaPushLoading, setRequestNSMediaPushLoading] = React.useState(false)

  // eslint-disable-next-line consistent-return
  const requestNSPush = async () => {
    setRequestNSPushLoading(true)
    try {
      const resp = await callApi({ method: 'get', path: API_ROUTES.requestNSPush })
      if (resp) {
        return resp
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    } finally {
      setRequestNSPushLoading(false)
    }
  }

  // eslint-disable-next-line consistent-return
  const requestNSMediaPush = async () => {
    setRequestNSMediaPushLoading(true)
    try {
      const resp = await callApi({ method: 'get', path: API_ROUTES.requestNSMediaPush })
      if (resp) {
        return resp
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    } finally {
      setRequestNSMediaPushLoading(false)
    }
  }

  return {
    requestNSPush,
    requestNSPushLoading,
    requestNSMediaPush,
    requestNSMediaPushLoading,
  }
}
